import React from "react";
import { Card, CardContent, Grid, Typography, useTheme } from "@mui/material";
import Avatar from "components/extended/Avatar";
import { gridSpacing } from "constants/theme"; import { useTranslation } from "react-i18next";

const ProfileCardComponent = ({ data }) => {
    const theme = useTheme()
    const { t } = useTranslation()

    return (
        <Card sx={{ border: `1px solid ${theme.palette.primary.light}` }}>
            <CardContent>
                <Grid container spacing={gridSpacing}>
                    <Grid item xs={12}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={2}>
                                <Avatar alt="Immagine profilo" sx={{ height: 80, width: 80 }} />
                            </Grid>

                            <Grid item container xs={12} sm={10} spacing={1}>
                                <Grid item xs={12} sx={{ display: "flex" }}>
                                    <Typography fontWeight={"bold"}>Email</Typography>
                                    <Typography>{`:  ${data?.email}`}</Typography>
                                </Grid>
                                {data?.firstName &&
                                    <Grid item xs={12} sx={{ display: "flex" }}>
                                        <Typography fontWeight={"bold"}>{t('Name')}</Typography>
                                        <Typography>{`:  ${data?.firstName}`}</Typography>
                                    </Grid>}

                                {data?.lastName &&
                                    <Grid item xs={12} sx={{ display: "flex" }}>
                                        <Typography fontWeight={"bold"}>{t('Last name')}</Typography>
                                        <Typography>{`:  ${data?.lastName}`}</Typography>
                                    </Grid>}

                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default ProfileCardComponent;
